import platform from '@propertypal/shared/src/utils/platform';
import Link from 'next/link';
import React from 'react';
import { useTheme } from 'styled-components';
import { Text } from '../typography';
import {
  FaqBg,
  FaqContactContainer,
  FaqContactWrapper,
  FaqContactContent,
  ButtonLink,
  FaqBgPn,
} from './FaqContactUs.style';

interface FaqContactUsProps {
  agent?: boolean;
}

const FaqContactUs: React.FC<FaqContactUsProps> = ({ agent }) => {
  const theme = useTheme();
  return (
    <FaqContactContainer data-testid="faq-contact">
      <FaqContactWrapper>
        <FaqContactContent>
          <Text fontSize={platform.select(24, 36)} fontWeight="bold" color={theme.textDark}>
            Can&apos;t find what you&apos;re looking for?
          </Text>
          <Text fontSize={platform.select(undefined, 24)} mt={5} mb={25}>
            Our customer support team is here to help.
          </Text>
          <Link href={`/faq/${agent ? 'agent-faq/' : ''}contact`} prefetch={false} data-testid="faq-contact-us-link">
            <ButtonLink>Get in touch</ButtonLink>
          </Link>
        </FaqContactContent>
        {platform.select(<FaqBg />, <FaqBgPn />)}
      </FaqContactWrapper>
    </FaqContactContainer>
  );
};

export default FaqContactUs;
